import * as actions from 'actions/groupPerformanceGroupsFilter';

const initialState = {
  groupPerformanceGroupsFilter: {
    total: 0,
    error: null,
    data: [],
    activeItems: [],
    loading: false,
  },
};

export default function groupPerformanceGroupsFilter(
  state = initialState,
  action,
) {
  const { type, payload } = action;

  switch (type) {
    case actions.RESET_GROUPPERFORMANCEGROUPS_FILTER: {
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }
    case actions.ACTIVE_GROUPPERFORMANCEGROUPS_FILTER: {
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          activeItems: payload,
        },
      };
    }
    case actions.ACTIVE_GROUPPERFORMANCEWIDGETGROUPS_FILTER: {
      if (
        (payload.length >= 1 && payload[0]?.id === 'groupsisupervise') ||
        payload[0]?.id === 'allgroups'
      ) {
        return {
          ...state,
          groupPerformanceGroupsFilter: {
            ...state.groupPerformanceGroupsFilter,
            activeItems: payload,
          },
        };
      }
      const newActiveItems = payload.filter(item =>
        state.groupPerformanceGroupsFilter.activeItems.find(
          a => a.id === item.id,
        ),
      );
      const activeItems = [
        ...state.groupPerformanceGroupsFilter.activeItems,
        ...newActiveItems,
      ];
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          activeItems,
        },
      };
    }
    case actions.GROUPPERFORMANCEGROUPS_SEARCH_START: {
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          loading: true,
        },
      };
    }
    case actions.GROUPPERFORMANCEGROUPS_SEARCH_SUCCESS: {
      const { data, total } = action.payload;
      if (data.length >= 1) {
        return {
          ...state,
          groupPerformanceGroupsFilter: {
            ...state.groupPerformanceGroupsFilter,
            data,
            total,
            loading: false,
          },
        };
      }
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          total,
          loading: false,
        },
      };
    }
    case actions.GROUPPERFORMANCEGROUPS_SEARCH_FAIL: {
      return {
        ...state,
        groupPerformanceGroupsFilter: {
          ...state.groupPerformanceGroupsFilter,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
}
